import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import type { IModelResponse } from "../base/dto/base.dto";
import { ModelHistoryLog } from "./dto/history-log.dto";

import { HistoryLogRepository } from "./history-log.repository";

export class HistoryLogService extends BaseService {
  private historyLogRepository = new HistoryLogRepository(
    this.api,
    this.configService
  );

  async getHistoryLogList(params: any): Promise<IModelResponse<ModelHistoryLog[]>> {
    let dataResult: IModelResponse<ModelHistoryLog[]> = {
      data: [],
    };
    try {
      const { $functions } = useNuxtApp();
      
      const res = await this.historyLogRepository.getHistoryLogList(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e) => new ModelHistoryLog(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log(
          'getHistoryLogList',
          resData,
          dataResult
        );
      }
    } catch (error) {
      console.error("Error fetching history log list:", error);
      throw error;
    }
    return dataResult;  
  }
    
}